import styled from 'styled-components';
export const Wrapper = styled.span`
  .link {
    font-weight: 900;
    font-size: 12px;
    line-height: 24px;
    color: #008cff;
    cursor: pointer;
    padding: 5px 0;
    margin-left: 4px;
  }
`;
